import type { EquipmentChoiceGroup } from '../../schemas/equipmentChoice';
import type { Item } from '../../schemas/equipment';

/**
 * Inferisce le selezioni di equipaggiamento dal `draft.inventory` esistente.
 *
 * Per ogni `EquipmentChoiceGroup`, confronta gli item nelle opzioni con
 * quelli presenti nell'inventory: un'opzione è considerata "selezionata" se
 * **tutti** i suoi item sono presenti nell'inventory con la stessa
 * `quantity` (per le opzioni che includono più item, come "Bastone + Falcetto"
 * del Monaco, devono esserci entrambi).
 *
 * **Esposto come helper riusabile** dalla `SectionEquipment` (per inferire
 * lo stato locale al rehydrate) e dal predicate `'equipment'` del reducer
 * (FI-28: per verificare che `pickCount` sia stato raggiunto per ogni gruppo).
 *
 * **Robusto al caso "draft non ancora popolato"**: tutti i gruppi
 * restituiscono array vuoti.
 */
export function inferEquipmentSelectionsFromInventory(
  inventory: readonly Item[],
  groups: readonly EquipmentChoiceGroup[],
): Record<string, string[]> {
  const result: Record<string, string[]> = {};
  for (const group of groups) {
    const matched: string[] = [];
    for (const opt of group.options) {
      const allOptionItemsPresent = opt.items.every((item) =>
        inventory.some((inv) => inv.id === item.id && inv.quantity === item.quantity),
      );
      if (allOptionItemsPresent && opt.items.length > 0) {
        matched.push(opt.id);
      }
    }
    result[group.id] = matched;
  }
  return result;
}
